<template>
  <Transition name="dropdown">
    <div v-if="isOpen"
      class="absolute top-full right-0 mt-2 bg-interactive-interactiveBg border border-border-line shadow-lg z-50"
      @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
      <div class="p-3" style="width: 20rem;">
        <p class="text-body2 text-t-primary">Please log in to your account by connecting your wallet to access your account settings.</p>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'LandingPageSettingsDropdown',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['mouseenter', 'mouseleave'],
  methods: {
    handleMouseEnter() {
      this.$emit('mouseenter')
    },
    handleMouseLeave() {
      this.$emit('mouseleave')
    }
  }
}
</script>

<style scoped>
/* Анимация появления dropdown */
.dropdown-enter-active,
.dropdown-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.dropdown-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
}
</style>

